import Color from 'color';

export class ColorToneGenerator {
    static createTones( inputColor: string ): { rgb: string, tone: number }[] {
        const color = new Color( inputColor );
        const hueValues = [ 0, .1, .2, .3, .4, .5, .6, .7, .8, .9, .95, .99, 1 ];
        return hueValues
            .map( el => {
                const toned = color.lightness( 100 * el );
                const hex = toned.hex();
                return { rgb: hex, tone: el };
            } );
    }

    static isDarkColor( inputColor: string ): boolean {
        return new Color( inputColor ).luminosity() < .5;
    }

    static generateScss( inputColor: string, baseName: string ): string {
        return this.createTones( inputColor )
            .map( el => `$${baseName}${( 100 * el.tone ).toFixed( 0 )}: ${el.rgb.toLowerCase()};` )
            .join( '\n' );
    }
}
